import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const validateCheckins = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/checkins/bulk/validate`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};

export const upsertCheckins = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/checkins/bulk/upsert`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};